import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_RESUBMIT_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractNegotiationCaseResubmit($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        resubmit
      }
    }
  }
`);
